import React from 'react';
import { object, func, string, array } from 'prop-types';

import styles from './OutlineTabs.scss';
import { themr } from 'react-css-themr';
const cx = require('classnames/bind').bind(styles);

/**
 * Provide following structure for array of tabs:
 *
 * [
 *   {
 *     key: ...
 *     title: ...
 *   },
 *   {
 *     key: ...
 *     title: ...
 *   }
 * ]
 *
 */

function OutlineTabs({ tabs, onTabSelect, activeTabKey, className, theme }) {
  const onTabClick = tab => () => onTabSelect(tab);
  const renderTabs = (tab, index) => {
    const { title, key } = tab;
    return (
      <li
        key={`${index}_${key}`}
        className={cx(theme.tabItem, {
          active: key === activeTabKey,
        })}
        onClick={onTabClick(tab)}
      >
        {title}
      </li>
    );
  };
  return <ul className={cx(theme.root, className)}>{tabs.map(renderTabs)}</ul>;
}
OutlineTabs.propTypes = {
  activeTabKey: string.isRequired,
  className: string.isRequired,
  tabs: array.isRequired,
  theme: object.isRequired,
  onTabSelect: func.isRequired,
};

export default themr('OutlineTabs', styles)(OutlineTabs);



// WEBPACK FOOTER //
// ./app/components/OutlineTabs/OutlineTabs.jsx